import { HttpClient } from './service'
import { IPagination } from '../types/pagination'

export interface BudgetSupplier {
  id?: number
  name: string
  contact: string
  created_at?: string
  updated_at?: string
}

class BudgetSuppliersApi {
  private basePath = '/api/budget-module/settings'

  // Get all suppliers (non-paginated)
  async getSuppliers(): Promise<BudgetSupplier[]> {
    return HttpClient.get<BudgetSupplier[], null>(`${this.basePath}/suppliers/all/`)
  }

  // Get paginated suppliers with search and ordering
  async getPaginatedSuppliers(params: {
    page?: number
    page_size?: number
    search?: string
    order?: string
  }): Promise<IPagination<BudgetSupplier[]>> {
    const queryParams = new URLSearchParams()
    if (params.page) queryParams.append('page', params.page.toString())
    if (params.page_size) queryParams.append('page_size', params.page_size.toString())
    if (params.search) queryParams.append('search', params.search)
    if (params.order) queryParams.append('order', params.order)

    const url = queryParams.toString()
      ? `${this.basePath}/suppliers/?${queryParams.toString()}`
      : `${this.basePath}/suppliers/`

    return HttpClient.get<IPagination<BudgetSupplier[]>, null>(url)
  }

  // Create a new supplier
  async createSupplier(data: BudgetSupplier): Promise<BudgetSupplier> {
    return HttpClient.post<BudgetSupplier, BudgetSupplier>(`${this.basePath}/suppliers/`, data)
  }

  // Update an existing supplier
  async updateSupplier(id: number, data: Partial<BudgetSupplier>): Promise<BudgetSupplier> {
    return HttpClient.patch<BudgetSupplier, Partial<BudgetSupplier>>(`${this.basePath}/suppliers/`, id, data)
  }

  // Delete a supplier
  async deleteSupplier(id: number): Promise<void> {
    return HttpClient.delete<void, void>(`${this.basePath}/suppliers/`, id)
  }

  // Bulk create suppliers
  async bulkCreateSuppliers(data: BudgetSupplier[]): Promise<BudgetSupplier[]> {
    return HttpClient.post<BudgetSupplier[], BudgetSupplier[]>(`${this.basePath}/suppliers/bulk_create/`, data)
  }

  // Bulk update suppliers
  async bulkUpdateSuppliers(data: BudgetSupplier[]): Promise<BudgetSupplier[]> {
    return HttpClient.post<BudgetSupplier[], BudgetSupplier[]>(`${this.basePath}/suppliers/bulk_update/`, data)
  }

  // Bulk delete suppliers
  async bulkDeleteSuppliers(ids: number[]): Promise<void> {
    return HttpClient.post<void, { ids: number[] }>(`${this.basePath}/suppliers/bulk_delete/`, { ids })
  }
}

export default new BudgetSuppliersApi()